var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnergyBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 46,
    viewBox: "0 0 262 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 76L23.2653 76L23.2653 31.8776C23.2653 30.8406 22.4247 30 21.3878 30L13.8775 30C12.8406 30 12 30.8406 12 31.8776L12 76Z",
    fill: "#4DAE67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6531 76L43.9184 76L43.9184 22.4898C43.9184 21.4529 43.0778 20.6122 42.0408 20.6122L34.5306 20.6122C33.4937 20.6122 32.6531 21.4529 32.6531 22.4898L32.6531 76Z",
    fill: "#4DAE67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3062 76L65.3062 76L65.3062 45.8776C65.3062 44.8406 64.4655 44 63.4286 44L55.1837 44C54.1468 44 53.3061 44.8406 53.3061 45.8776L53.3062 76Z",
    fill: "#E64646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6938 76L85.9592 76L85.9591 25.3061C85.9591 24.2692 85.1185 23.4286 84.0816 23.4286L76.5714 23.4286C75.5344 23.4286 74.6938 24.2692 74.6938 25.3061L74.6938 76Z",
    fill: "#4DAE67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3469 76L106.612 76L106.612 41.2653C106.612 40.2284 105.772 39.3878 104.735 39.3878L97.2245 39.3878C96.1875 39.3878 95.3469 40.2284 95.3469 41.2653L95.3469 76Z",
    fill: "#E64646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 76L127 76L127 38.8776C127 37.8406 126.159 37 125.122 37L117.878 37C116.841 37 116 37.8406 116 38.8776L116 76Z",
    fill: "#E64646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 76L148 76L148 9.87755C148 8.84061 147.159 8 146.122 8L137.878 8C136.841 8 136 8.84061 136 9.87755L136 76Z",
    fill: "#4DAE67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 76L168 76L168 25.8776C168 24.8406 167.159 24 166.122 24L158.878 24C157.841 24 157 24.8406 157 25.8776L157 76Z",
    fill: "#E64646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 76L189 76L189 13.8776C189 12.8406 188.159 12 187.122 12L179.878 12C178.841 12 178 12.8406 178 13.8776L178 76Z",
    fill: "#4DAE67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 76L209 76L209 1.87755C209 0.840606 208.159 -9.46087e-07 207.122 -8.49523e-07L199.878 -1.74846e-07C198.841 -7.82812e-08 198 0.840607 198 1.87755L198 76Z",
    fill: "#4DAE67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 76L230 76L230 25.8776C230 24.8406 229.159 24 228.122 24L220.878 24C219.841 24 219 24.8406 219 25.8776L219 76Z",
    fill: "#4DAE67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 76L251 76L251 9.87755C251 8.84061 250.159 8 249.122 8L240.878 8C239.841 8 239 8.84061 239 9.87755L239 76Z",
    fill: "#4DAE67"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyBg);
export default __webpack_public_path__ + "static/media/energy-bg.bc2a4bb37e28307427e97fdc550978a2.svg";
export { ForwardRef as ReactComponent };